// This utility function helps in resolving paths to assets.
// In a standard Create React App setup, you can import images directly.
// However, to match the new footer's structure, we'll use this helper.

export const getImagePath = (imageName) => {
  try {
    // The `require` function here dynamically imports the image at build time.
    return require(`../assets/${imageName}`);
  } catch (err) {
    console.error(`Failed to load image: ${imageName}`, err);
    return ''; // Return a fallback or empty string if the image is not found.
  }
};
